require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./boutique-epfl-1-1-15.json") })
        }
      }, "path---boutique-epfl-1-1-15");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---boutique-epfl-1-1-15!./.cache/json/boutique-epfl-1-1-15.json
// module id = 352
// module chunks = 231608221292675